import Flex from "@irati/ui/src/Flex"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import Spacing from "@irati/ui/src/Spacing"
import {Body, H2} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import React from "react"
import styled, {css} from "styled-components"

const cycle_solution = "https://res.cloudinary.com/perkbox/image/upload/v1753366047/948f9907-1a17-4a8f-b33f-91dd0ec2b9bc.jpg"
const decathlon = "https://res.cloudinary.com/perkbox/image/upload/v1753366097/ace3ebb9-fc5c-4e53-9d3d-c263b73fa496.jpg"
const cycle_image = "https://res.cloudinary.com/perkbox/image/upload/v1753368866/f47ab002-428f-46c8-9e3d-658c940c8b45.jpg"

export const FindABike = () => {
  return (
    <Spacing marginTop={6} marginBottom={6}>
      <Container>
        <Content>
          <H2 marginBottom={2.5}>
            <FormattedMessage id="platform.payrollpay.store.landing.c2w.findABike.title" />
          </H2>
          <Body>
            <FormattedMessage id="platform.payrollpay.store.landing.c2w.findABike.content" />
          </Body>
          <Flex marginTop={4} marginBottom={4} gap={1} wrap="wrap">
            <img src={cycle_solution} height={27} alt="cycle solution" />
            <img src={decathlon} height={27} alt="decathlon" />
          </Flex>
          <Button primary large to="/find_a_bike_shop">
            <FormattedMessage id="platform.payrollpay.store.landing.c2w.findABike.button" />
          </Button>
        </Content>

        <ImageContainer>
          <CycleImage src={cycle_image} alt="find a bike" />
        </ImageContainer>
      </Container>
    </Spacing>
  )
}

const Container = styled(Flex)`
  ${({theme}) => css`
    border-radius: ${theme.border.radius.extraLarge};
    flex-direction: row;
    background-color: ${theme.colors.greys.white};
    box-shadow: ${theme.shadows.low};
    width: 100%;
    border: 1px solid ${theme.colors.greys.grey20};
  `}
`

const Content = styled(Flex)`
  ${({theme}) => css`
    flex: 1;
    flex-direction: column;
    justify-content: center;
    padding: ${theme.spacing.three} ${theme.spacing.two};
    ${theme.mediaQueries.minWidthMedia.tablet`
      padding: ${theme.spacing.three} ${theme.spacing.six};
    `}
  `}
`

const ImageContainer = styled.div`
  ${({theme}) => css`
    display: none;
    ${theme.mediaQueries.minWidthMedia.desktop`
    flex: 1 1 9%;
      display: block;
    `}
  `}
`

const CycleImage = styled.img`
  ${({theme}) => css`
    height: 100%;
    width: 100%;
    object-fit: cover;
    border-top-right-radius: ${theme.border.radius.extraLarge};
    border-bottom-right-radius: ${theme.border.radius.extraLarge};
  `}
`

const Button = styled(ButtonRouterLink)`
  ${({theme}) => css`
    ${theme.mediaQueries.minWidthMedia.desktop`
      width: 164px;
    `}
  `}
` as typeof ButtonRouterLink
